import { createFileRoute } from '@tanstack/react-router';

import { CitationCreate } from '@/module/Author/Citation/CitationCreate';

export const Route = createFileRoute('/_auth/author/_author/article/_article/$articleId/_layout/citations/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  const { articleId } = Route.useParams();

  return <CitationCreate publicationId={Number(articleId)} />;
}
